export default __webpack_public_path__ + "static/media/03.1e33b27e.png";